module.exports = __webpack_public_path__ + "img/Lightning_Potion.ace23148.png";